import { render, staticRenderFns } from "./StartClass.vue?vue&type=template&id=77b287ac&scoped=true&"
import script from "./StartClass.vue?vue&type=script&lang=js&"
export * from "./StartClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b287ac",
  null
  
)

export default component.exports